import { AuthContext } from "../Context/ContextApi"
import {useContext} from "react"
function Login (){
    const {toggleAuth} = useContext(AuthContext)
    return(
        <>
    <h1>Login</h1>
    <button onClick={toggleAuth}> Login</button>
    </>
    )
}

export default Login